module.exports = __webpack_public_path__ + "static/img/quancheng_011.053326d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_011.png
// module id = T6/m
// module chunks = 1